import type { ModelItem, ModelListParams, ModelListResponse } from '@/types/model'
import { httpClient } from '@/utils/request'

const BASE_URL = '/models'

// 对应后端的 ModelPublic Schema
export interface BackendModelPublic {
  id: string
  serial_number: string
  author_id: string
  status: string
  reject_reason: string | null
  view_count: number
  download_count: number
  favorite_count: number
  published_at: string | null
  created_at: string
  updated_at: string
  title: string
  cover_image: string
  software: string
  format: string
  price: number
  is_free: boolean
  is_liked?: boolean
}

interface BackendModelListResponse {
  data: BackendModelPublic[]
  count: number
}

export async function getModelList(params: ModelListParams): Promise<ModelListResponse> {
  const res = await httpClient.get<BackendModelListResponse>(BASE_URL, { params })

  // Transform backend fields to frontend ModelItem requirements
  const list = (res.data || []).map((item: BackendModelPublic): ModelItem => ({
    // 将后端蛇形命名或其他字段映射到前端驼峰及预设结构
    id: item.id,
    name: item.title || '',
    title: item.title,
    imageUrl: item.cover_image || '',
    software: item.software,
    format: item.format,
    price: item.price,
    views: item.view_count || 0,
    downloads: item.download_count || 0,
    likes: item.favorite_count || 0,
    isLiked: item.is_liked ?? false,
    createdAt: item.created_at,
    status: item.status as ModelItem['status'],
    isFree: item.is_free,
  }))

  return {
    list,
    total: res.count || 0,
    page: params.page || 1,
    pageSize: params.pageSize || 20,
  }
}

export async function getModelSoftwareList(): Promise<string[]> {
  const res = await httpClient.get<{ name: string }[]>(`${BASE_URL}/software`)
  return res.map(item => item.name)
}
